<div class="h-100 single-report-page">
    <app-admin-report [columns]="shippedPackagesReport" [hasFilters]="true" [apiUrl]="shippedPackagesReportAPI"
                      reportTitle="ADMINISTRATION.SHIPPED_PACKAGES_DETAILED_REPORT_TITLE" [filterCustomer]="true">
    </app-admin-report>
</div>